<template>
  <div id="bimface" class="bimface" :class="{'bimface-annotation': showAnnotation}">
    <!-- 批注列表 -->
    <bimface-annotation
      v-if="!isOffline && !['COMPONENT'].includes(this.from) && showAnnotation"
      ref="annotationPanel"
      :space-id="spaceId"
      :file-id="fileId"
      :from-page="from"
      :file-type="fileType"
      :share-code="shareCode"
      :viewer3D="viewer3D"
      :app="app"
      :is-in-annotation="isAnnotationMode"
      @close="annotationClose"
      @change-mouse="mouseAnnotation"
      @change-mouse-default="mouseDefault"
      @add-annotation="handleAddAnnotation"
      @cancel-annotation="exitAnnotationMode"
      @annotation-created="onAnnotationCreated"
      @require-login="handleRequireLogin"
    />
    <!-- 视点管理 -->
    <vue-drag-resize v-if="positionCalculated && showViewPoint" :parent-limitation="true" w="auto" h="auto" :z="99" :is-resizable="false" drag-handle=".custom-title" :x="10" :y="initialY">
      <div class="custom-title">
        <span style="cursor: text">视点管理</span>
        <!-- offline项目里也要展示，所以最好用图片，不要使用iconfont，样式会有问题 -->
        <img src="@/assets/img/icon_close@2x.png" class="close-icon" width="16" @click="viewPointClose" />
      </div>
      <div class="custom-content">
        <el-button v-if="!isOffline && from !== 'SHARE'" type="primary" plain class="create-viewpoint-btn" @click="createViewpoint">新建视点（{{viewpoints.length}}/20）</el-button>
        <ul v-if="viewpoints.length" class="viewpoint-list">
          <li v-for="(view, index) in viewpoints" :key="index" class="viewpoint-list-item">
            <div class="viewpoint-item" @click="setState(view.state)">
              <div class="viewpoint-thumbnail">
                <img :src="getViewpointThumbnail(view.thumbnail)" />
              </div>
              <div class="viewpoint-info">
                <div class="viewpoint-name">
                  <span :title="view.name">{{ view.name }}</span>
                </div>
              </div>
            </div>
            <el-dropdown v-if="!isOffline && from !== 'SHARE'" class="viewpoint-operation" placement="bottom" trigger="hover" @click.stop="">
              <span class="el-dropdown-link">
                <i class="iconfont icon-gengduo"/>
              </span>
              <el-dropdown-menu slot="dropdown" class="dark-style">
                <el-dropdown-item @click.native.stop="editViewpoint(view)">
                  <span>编辑</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native.stop="deleteViewpoint(view)">
                  <span class="red-bg">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
        <div v-else class="empty-content">
          <img src="@/assets/img/data_empty.png" width="100" alt="" />
          <p>暂无内容</p>
        </div>
      </div>
    </vue-drag-resize>
    <div
      v-if="!showError && (status==='success' || status === 'loading')"
      ref="viewer"
      class="viewer fill"
      :style="{width:`${width}`,height:`${height}`}"
    />
    <div
      v-if="status === 'error' || showError"
      class="noToken fill flex-col-center"
    >
      <div class="flex-col-center">
        <img src="./../../assets/img/icon_3d.png" alt="" />
        <span>暂不支持预览</span>
      </div>
    </div>
    <div
      v-if="!showError && status === 'loading'"
      class="loading fill flex-col-center"
    >
      <span>正在加载模型，请稍候</span>
    </div>
  <!--  新增视点  -->
    <gjw-dialog
        :show-dialog="showViewPointDialog"
        :config="{ width: '424px' , class: 'bimface-dialog' }"
        :title="editType === 'edit' ? '编辑视点' : '新增视点'"
        :confirm-loading="dialogLoading"
        @close="closeDialog"
        @confirm="confirmDialog"
    >
      <el-form ref="dialogForm" :model="form" label-width="80px" label-position="left" :rules="rules">
        <el-form-item label="视点名称:" prop="name">
          <el-input v-model="form.name" placeholder="最长50个字符" maxlength="50" />
        </el-form-item>
        <el-form-item label="缩略图:">
          <div class="viewpoint-img">
            <img :src="$hosts.static(form.thumbnail)" />
          </div>
        </el-form-item>
      </el-form>
    </gjw-dialog>
  </div>
</template>
<script>
import Tools from '@/core/tools'
import { RegSymbol } from '@/core/RegExp'
import BimfaceAnnotation from './BimfaceAnnotation.vue'
/* eslint-disable */
export default {
  components: {
    BimfaceAnnotation
  },
  props: {
    // 是否是离线包模式
    isOffline:{ type: Boolean, default:false },
    // 离线包模型目录名称
    modelDirName: { type: String, default: '' },
    fileId: [String, Number],
    // 构件:COMPONENT; 文件:FILE; 合模方案:FEDERATED_PLAN; 整合模型:INTEGRATED_MODEL; 合模预览:FEDERATED_PREVIEW; 分享:SHARE;
    from: String,
    // 文件:FILE; 合模方案:FEDERATED_PLAN; 整合模型:INTEGRATED_MODEL;
    fileType: String,
    viewToken: [String, Number],
    isMultiple:{ type: Boolean, default: false },
    multipleViewToken: { // [{modelId, viewToken}]
      type:Array,
      default(){
        return []
      }
    },
    width: [String, Number],
    height: [String, Number],
    familyType: [String],
    configButtons: Array,
    // 当父级接口报错时，可通过该字段强制显示错误
    showError:{
      type: Boolean,
      default: false
    },
  },
  data() {
    const customValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入视点名称'))
      }else if(RegSymbol.test(value)) {
        callback(new Error('名称不能包含特殊字符'))
      }else {
        callback()
      }
    }
    return {
      spaceId: this.isOffline ? null : this.$route.params.spaceId,
      shareCode: this.isOffline ? null : this.$route.params.shareCode,
      app: null,
      status: 'loading',
      loaded: false,
      viewer3D: null,
      viewpoints: [],
      showViewPoint: false,
      showViewPointDialog: false,
      showAnnotation: false,
      isAnnotationMode: false, // 是否处于批注模式
      editType: 'add',
      currentEditInfo: {},
      dialogLoading: false,
      initialY: 0,
      positionCalculated: false,
      rules: {
        name: [
          { validator: customValidate, trigger: 'blur' },
        ],
      },
      form: {
        name: '',
        thumbnail: '',
      },
    };
  },

  watch: {
    familyType(newValue) {
      if (this.app) {
        try {
          const viewer = this.app.getViewer();
          viewer.showFamilyTypeByName(newValue);
        } catch (error) {
          console.error(error)
        }
      }
    },
    viewToken(newVal, oldValue) {
      this.status = "loading";
      this.$nextTick(() => {
        const view = this.$refs.viewer;
        const children = view.childNodes;
        for (let i = children.length - 1; i >= 0; i--) {
          view.removeChild(children[i]);
        }
        this.initializeBimface();
      });
    },
    multipleViewToken(newVal, oldValue) {
      const tokens1 = newVal.map(item=>item.viewToken)
      const tokens2 = oldValue.map(item=>item.viewToken)
      if(Tools.isArraysEqual(tokens1, tokens2)){
        return
      }
      this.status = "loading"
      this.loaded = false
      this.$nextTick(() => {
        const view = this.$refs.viewer;
        const children = view.childNodes;
        for (let i = children.length - 1; i >= 0; i--) {
          view.removeChild(children[i]);
        }
        this.initializeBimface();
      });
    },
  },
  mounted() {
    if(this.from !== 'COMPONENT'){
      this.getViewPointerList()
      this.calculateInitialPosition()
    }
    if(this.isOffline){
      this.initOfflineBimface()
    }else{
      this.initializeBimface()
    }
  },

  methods: {
    calculateInitialPosition() {
      // 延迟执行，确保DOM完全渲染
      setTimeout(() => {
        const parentElement = this.$el
        if (parentElement && parentElement.offsetHeight) {
          const parentHeight = parentElement.offsetHeight
          // 计算距离底部60px的位置
          // custom-content高度是500px，加上标题高度约30px
          const windowHeight = 530
          this.initialY = Math.max(0, parentHeight - windowHeight - 60)
        } else {
          // 如果无法获取父元素高度，使用默认值
          this.initialY = 200
        }
        // 标记位置计算完成
        this.positionCalculated = true
      }, 100)
    },
    // 获取视点列表
    async getViewPointerList(){
      if(this.from === 'FEDERATED_PREVIEW'){
        this.viewpoints = []
        return
      }
      try{
        let res = []
        if(this.isOffline){
          // 离线模式：从静态资源获取视点数据
          res = await this.getOfflineViewPoints()
        }else if(this.from === 'SHARE'){
          res = await this.$api.viewpoint.listByShareCode(this.shareCode)
        }else{
          const query = { file_id: this.fileId, type: this.fileType }
          res = await this.$api.viewpoint.list(this.spaceId, query)
        }
        this.viewpoints = res || []
      }catch (e) {
        console.error('Failed to get viewpoints:', e)
        this.viewpoints = []
      }
    },
    // 离线模式获取视点数据
    async getOfflineViewPoints(){
      if(!this.fileId){
        console.error('fileId is required for offline viewpoints')
        return []
      }
      try{
        const v = new Date().getTime()
        const response = await fetch(`./team-space/view-point/view_point.json?v=${v}`)
        if(!response.ok){
          throw new Error(`Failed to fetch view_point.json: ${response.status}`)
        }
        return await response.json()
      }catch(e){
        console.error('Failed to load offline viewpoints:', e)
        return []
      }
    },
    addBimfaceSdk() {
      if (window.BimfaceSDKLoaderConfig === undefined) {
        const script = document.createElement("script");
        script.src = process.env.VUE_APP_BIMFACE_LOADER_SDK
        script.charset = "utf-8";
        document.body.appendChild(script);
        const script1 = document.createElement("script");
        script1.src = process.env.VUE_APP_BIMFACE_HOST_CONFIG_JS
        script1.charset = "utf-8";
        document.body.appendChild(script1);
      }
    },
    // 离线加载
    initOfflineBimface(){
      if(window.BimfaceSDKLoaderConfig === undefined){
        return
      }
      if(!this.modelDirName){
        console.error('modelDirName is required for offline mode')
        this.status = "error"
        return
      }
      this.status = "loading"
      let bimfaceLoaderConfig = new BimfaceSDKLoaderConfig();
      let that = this
      bimfaceLoaderConfig.dataEnvType = BimfaceEnvOption.Local;
      bimfaceLoaderConfig.sdkPath = './jssdk';
      bimfaceLoaderConfig.path = `./models/${this.modelDirName}/viewToken.json`;
      BimfaceSDKLoader.load(
          bimfaceLoaderConfig,
          (viewMetaData)=>{
            this.status = "success";
            this.loaded=true
            const view = this.$refs.viewer;
            if (viewMetaData.viewType === "3DView") {
              // ======== 判断是否为3D模型 ========
              let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
              webAppConfig.Toolbars = ["ModelTree", "MainToolbar"];
              webAppConfig.MobileToolbars = ["ModelTree", "MainToolbar"]
              webAppConfig.domElement = view;
              this.app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
              // 从WebApplication获取viewer3D对象
              let viewer3D = this.viewer3D = this.app.getViewer();
              console.log(viewMetaData, 11)
              viewer3D.loadModel({viewMetaData})
              // 监听添加view完成的事件
              viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
                console.log('Offline ViewAdded')
                //自适应屏幕大小
                window.onresize=function(){
                  viewer3D.resize(document.documentElement.clientWidth,document.documentElement.clientHeight)
                }
                // 增加视点按钮
                that.addViewPointBtn(that)
                // 渲染3D模型
                viewer3D.render();
              });
            }
          },
          (error)=>{
            this.loaded = false
            this.status = "error";
          })
    },
    // 在线加载
    initializeBimface() {
      if(this.loaded){return}
      if (this.viewToken === "loading") return;
      this.addBimfaceSdk()
      if(window.BimfaceSDKLoaderConfig === undefined){
        return
      }
      this.status = "loading"
      let bimfaceLoaderConfig = new BimfaceSDKLoaderConfig();
      let tokenLength = 0
      let firstModel = {}
      if(this.isMultiple){
        tokenLength = this.multipleViewToken.length
        firstModel = this.multipleViewToken[0] || {}
      }
      if(tokenLength || this.viewToken){
        let that = this
        let viewToken = this.isMultiple ? firstModel.viewToken : this.viewToken
        try {
            bimfaceLoaderConfig.viewToken = viewToken
            BimfaceSDKLoader.load(
                bimfaceLoaderConfig,
                viewMetaData => {
                  this.status = "success";
                  this.loaded=true
                  const view = this.$refs.viewer;
                  if (viewMetaData.viewType === "3DView") {
                    // ======== 判断是否为3D模型 ========
                    let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                    webAppConfig.Toolbars = ["ModelTree", "MainToolbar"];
                    webAppConfig.MobileToolbars = ["ModelTree", "MainToolbar"]
                    if(this.configButtons && this.configButtons.length){
                      webAppConfig.Buttons = this.configButtons
                      webAppConfig.MobileButtons = this.configButtons
                    }
                    webAppConfig.domElement = view;
                    var viewAdded = false;
                    // 创建WebApplication
                    this.app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                    // 从WebApplication获取viewer3D对象
                    let viewer3D = this.viewer3D = this.app.getViewer();
                    if(this.isMultiple){
                      // 添加待显示的模型
                      viewer3D.loadModel({ ...firstModel })
                    }else{
                      // 添加待显示的模型
                      this.app.addView(this.viewToken);
                    }
                    // 监听添加view完成的事件
                    viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
                      console.log('ViewAdded')
                      viewAdded = true
                      //自适应屏幕大小
                      window.onresize=function(){
                        viewer3D.resize(document.documentElement.clientWidth,document.documentElement.clientHeight-40)
                      }
                      // 增加自定义按钮
                      if(!that.isMultiple && that.from !== 'COMPONENT'){
                        that.addViewPointBtn(that)
                        that.addAnnotationBtn(that)
                      }
                      // 渲染3D模型
                      viewer3D.render();
                    });
                    // 对于多模型加载时，添加额外的监听事件
                    if(this.isMultiple){
                      // 添加模型加载完成的监听事件，对加载的模型进行初始位置移动
                      viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ModelAdded, function (data) {
                        console.log("modelId:" + data)
                        if(!data ){ return }
                        const index = data.split('_')[0] - 0
                        const nextModel = that.multipleViewToken[index + 1]
                        if(nextModel){
                          viewer3D.loadModel({ ...nextModel })
                        }else if(that.from !== 'COMPONENT'){
                          // 当所有模型都加载完成后，新增自定义的工具栏按钮
                          setTimeout(() => {
                              that.addViewPointBtn(that)
                              that.addAnnotationBtn(that)
                            }, 100)
                        }
                      });
                    }
                    return
                  }
                  // 对于非 3d 模型，不考虑多模型加载的情况
                  if(this.viewToken){
                    window.Glodon.Bimface.Viewer.Viewer3D.prototype.getFamilyTypesAsync = function () {
                      return new Promise((resolve, reject) => {
                        this.getFamilyTypes((data) => {
                          resolve(data);
                        })
                      });
                    }
                    window.Glodon.Bimface.Viewer.Viewer3D.prototype.showFamilyTypeByName = async function (name) {
                      let types = await this.getFamilyTypesAsync();
                      if (!types) {
                        const resourceHost = this._opt.resourceHost;
                        const databagId = this._data.databagId;
                        const familytypes = await fetch(`${resourceHost}/${databagId}/metadata/familyInfo.json`).then(response => response.json());
                        if (familytypes) {
                          types = familytypes.types;
                        }
                      }
                      if (types) {
                        const type = types.find(t => t.name === name);
                        if (type) {
                          this.showFamilyTypeById(type.id)
                        }
                      }
                    }
                    var webAppConfig = new Glodon.Bimface.Application.WebApplicationRfaConfig();
                    if(this.configButtons && this.configButtons.length){
                      webAppConfig.Buttons = this.configButtons
                    }
                    webAppConfig.domElement = view;
                    webAppConfig.enableViewHouse = false;
                    webAppConfig.enableOrbit = true;
                    var appEvents = Glodon.Bimface.Application.WebApplicationRfaEvent;
                    this.app = new Glodon.Bimface.Application.WebApplicationRfa(webAppConfig);
                    this.app.addView(this.viewToken);
                    CLOUD.GlobalData.UseBatchRendering = true;
                    this.app.addEventListener(appEvents.ViewAdded, () => {
                      this.app
                          .getViewer()
                          .setView(Glodon.Bimface.Viewer.ViewOption.Home);
                      this.app.getViewer().startAutoRotate(0.5);
                      this.app
                          .getViewer()
                          .addEventListener("FamilyTypeChanged", name =>
                              this.$emit("family-type-changed", name)
                          );
                      this.app.render();
                    });
                    this.app.addEventListener(appEvents.ViewLoading, function(progress) {
                      console.log(progress);
                    });
                    this.app.addEventListener(
                        appEvents.ComponentsSelectionChanged,
                        function(data) {
                          console.log(data);
                        }
                    );
                    this.app.addEventListener(appEvents.Error, data => {
                      console.log(data)
                      this.loaded = false
                      this.status = "error";
                    });
                  }
                },
                error => {
                  this.loaded = false
                  this.status = "error";
                }
            );
          } catch (e) {
            console.log(e);
            this.status = "error";
          }
      } else {
        this.status = "error";
      }
    },
    // 添加批注按钮
    addAnnotationBtn(that){
      const toolbar = that.app.getToolbar('MainToolbar');
      let annotationBtnConfig = new Glodon.Bimface.UI.Button.ButtonConfig();
      annotationBtnConfig.title = '批注'
      annotationBtnConfig.id = 'Annotation'
      const annotationBtn = new Glodon.Bimface.UI.Button.Button(annotationBtnConfig);
      annotationBtn.addClassName('bf-btn-pizhu gld-bf-annotation')
      annotationBtn.addEventListener('click', function(){
        if(that.from === 'FEDERATED_PREVIEW'){
          that.$message.error('请保存方案后再尝试')
          return
        }
        that.showAnnotation = !that.showAnnotation
        if(that.showAnnotation){
          annotationBtn.addClassName('bf-checked')
        }else{
          that.exitAnnotationMode()
          annotationBtn.removeClassName('bf-checked')
        }
      })
      toolbar.insertControl(5, annotationBtn)
    },
    // 批注面板关闭
    annotationClose(){
      this.showAnnotation = false
      const toolbar = this.app.getToolbar('MainToolbar')
      const btn = toolbar.getControl('Annotation')
      if(btn){
        btn.removeClassName('bf-checked')
      }
      // 退出批注模式
      if(this.isAnnotationMode){
        this.exitAnnotationMode()
      }
    },
    // 进入批注模式
    handleAddAnnotation(){
      // 先移除可能存在的旧监听器，避免重复添加
      this.viewer3D.removeEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, this.onModelClick)
      // 添加鼠标点击事件监听
      this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, this.onModelClick)
      this.isAnnotationMode = true
      // 开启构件鼠标悬停效果
      this.viewer3D.enableHover(true)
      // 修改鼠标样式为批注图标
      this.mouseAnnotation()
    },
    // 退出批注模式
    exitAnnotationMode(){
      // 移除鼠标点击事件监听
      this.viewer3D.removeEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, this.onModelClick)
      this.isAnnotationMode = false
      // 关闭构件鼠标悬停效果
      this.viewer3D.enableHover(false)
      // 恢复鼠标样式为默认
      this.mouseDefault()
    },
    // 恢复鼠标样式为默认
    mouseDefault(){
      const viewerElement = this.$refs.viewer
      if (viewerElement) {
        viewerElement.style.cursor = 'default'
      }
    },
    // 修改鼠标样式为批注图标
    mouseAnnotation(){
      const viewerElement = this.$refs.viewer
      if (viewerElement) {
        viewerElement.style.cursor = `url(${require('@/assets/img/mouse-pizhu-icon.png')}) 20 40, all-scroll`
      }
    },
    // 模型点击事件
    onModelClick(event){
      if(!this.isAnnotationMode) return

      // 如果没有选中构件，提示用户
      if(!event.elementId){
        this.$message.info('请在画布中拾取构件')
        return
      }

      // 选中构件，触发批注编辑对话框
      if(this.$refs.annotationPanel){
        this.$refs.annotationPanel.showAnnotationDialog({
          elementId: event.elementId,
          position: {
            x: event.clientPosition.x,
            y: event.clientPosition.y
          }
        })
      }
    },
    // 批注创建完成
    onAnnotationCreated(){
      // 退出批注模式
      this.exitAnnotationMode()
    },
    // 批注需要登录
    handleRequireLogin(){
      // 通知父组件需要登录
      this.$emit('require-login')
    },
    // 添加视点管理按钮
    addViewPointBtn(that){
      const toolbar = that.app.getToolbar('MainToolbar');
      let viewPointBtnConfig = new Glodon.Bimface.UI.Button.ButtonConfig();
      viewPointBtnConfig.title = '视点管理'
      viewPointBtnConfig.id = 'ViewpointManage'
      const viewPointBtn = new Glodon.Bimface.UI.Button.Button(viewPointBtnConfig);
      //设置新增按钮的样式
      viewPointBtn.addClassName('bf-btn-shidian gld-bf-viewpoint-manage')
      viewPointBtn.addEventListener('click', function(){
        if(that.from === 'FEDERATED_PREVIEW'){
          that.$message.error('请保存方案后再尝试')
          return
        }
        that.showViewPoint = !that.showViewPoint
        if(that.showViewPoint){
          viewPointBtn.addClassName('bf-checked')
        }else{
          viewPointBtn.removeClassName('bf-checked')
        }
      })
      //设置按钮的位置
      toolbar.insertControl(4, viewPointBtn)
    },
    setState(stateStr){
      const state = stateStr ? JSON.parse(stateStr) : {}
      this.viewer3D.setState(state)
      if(!this.isOffline){
        this.$tracks({
          event: 'viewViewPoint',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: this.fileId,
            g_c_file_type: this.from,
          }
        })
      }
    },
    // 获取视点缩略图路径
    getViewpointThumbnail(thumbnail){
      if(!thumbnail) return ''
      if(this.isOffline){
        // 离线模式：使用相对路径
        return `./${thumbnail}`
      }
      // 在线模式：使用静态资源地址
      return this.$hosts.static(thumbnail)
    },
    createViewpoint(){
      if(this.viewpoints.length >= 20){
        this.$message.warning('最多创建20个视点')
        return
      }
      // 获取视点截图
      let that = this
      let bgColor = new Glodon.Web.Graphics.Color(214, 224, 235, 0.7);
      this.viewer3D.createSnapshotAsync(bgColor, function(data) {
        that.form.thumbnail = data
      })
      this.openDialog('add')
    },
    // 视点按钮点击事件
    viewPointClose(){
      this.showViewPoint = !this.showViewPoint
      const toolbar = this.app.getToolbar('MainToolbar')
      const btn = toolbar.getControl('ViewpointManage')
      btn.removeClassName('bf-checked')
    },
    openDialog(type){
      this.showViewPointDialog = true
      this.editType = type || 'add'
    },
    closeDialog(){
      this.showViewPointDialog = false
      this.$refs.dialogForm.resetFields()
      this.form = {
        name: '',
        thumbnail: '',
      }
    },
    confirmDialog(){
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          // 如果是编辑，且名称一样，则不进行编辑
          if (this.editType === 'edit' && this.form.name === this.currentEditInfo.name) {
            this.dialogLoading = false
            this.showViewPointDialog = false
            return
          }
          this.dialogLoading = true
          try {
            if (this.editType === 'edit') {
              // 编辑视点
              const params = {
                name: this.form.name,
              }
              await this.$api.viewpoint.update(this.spaceId, this.form.id, params)
              this.$message.success('保存成功')
              this.$tracks({
                event: 'modifyViewPoint',
                params: {
                  g_c_space_id: this.spaceId,
                  g_c_file_id: this.fileId,
                  g_c_file_type: this.fileType,
                }
              })
            } else {
              // 新增视点
              const state = this.viewer3D.getCurrentState()
              const params = {
                name: this.form.name,
                thumbnail: this.form.thumbnail || '',
                fileId: this.fileId,
                type: this.fileType,
                state: state ? JSON.stringify(state) : null,
              }
              await this.$api.viewpoint.create(this.spaceId, params)
              this.$tracks({
                event: 'newViewPoint',
                params: {
                  g_c_space_id: this.spaceId,
                  g_c_file_id: this.fileId,
                  g_c_file_type: this.fileType,
                }
              })
              // this.viewpoints.push({name: this.form.name, state, thumbnail: this.form.thumbnail})
              this.$message.success('创建成功')
            }
            this.dialogLoading = false
            this.showViewPointDialog = false
            await this.getViewPointerList()
          } catch (error) {
            const errors = {
              'view.point.not.exist': '视点不存在',
              'duplicate.name.error': '视点名称已存在',
              'name.contain.special.characters': '名称包含特殊字符',
              'view.point.limit.exceed': '超出数量限制',
              'state.is.empty': '模型状态为空',
              'name.length.exceed': '名称长度超出限制',
            }
            this.$matchError(error.code, errors, '操作失败')
            this.dialogLoading = false
          }
        } else {
          this.dialogLoading = false
        }
      })
    },
    editViewpoint(view){
      this.currentEditInfo = view
      this.form = {
        id: view.id,
        name: view.name,
        thumbnail: view.thumbnail,
      }
      this.openDialog('edit')
    },
    deleteViewpoint(view){
      this.$confirm(`是否确认删除"${view.name}"？`,'', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        customClass: 'dark-confirm delete-warning'
      }).then(async () => {
        try {
          await this.$api.viewpoint.remove(this.spaceId, view.id)
          this.$message.success('删除成功')
          this.$tracks({
            event: 'deleteViewPoint',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: this.fileId,
              g_c_file_type: this.fileType,
            }
          })
          await this.getViewPointerList()
        } catch (err) {
          this.$matchError(err.code, {}, '删除失败')
        }
      }).catch(() => {})
    },
  }
};
</script>
<style lang="less">
.flex-col-center{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bimface {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: white;
  position: relative;
  .fill {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .noToken,
  .loading {
    font-size: 14px;
  }
  .noToken{
    img{
      width: 400px;
      max-width: 100%;
    }
    span{
      position: relative;
      top: -80px;
    }
  }
  .viewer{
    .bf-toolbar-select[title=FamilyTypes]{
      display: none;
    }
  }
  .custom-title{
    background: #000000;
    border: 1px solid #4F4F4F;
    color: #FFFFFF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    cursor: move;
    .close-icon{
      cursor: pointer;
    }
  }
   .custom-content{
     width: 324px;
     height: 480px;
     display: flex;
     flex-direction: column;
     background: rgba(0, 0, 0, 0.8);
     border: 1px solid #4F4F4F;
     color: rgba(255, 255, 255, 0.65);

     .create-viewpoint-btn{
       flex: 0 0 32px;
       width: 155px;
       margin: 12px 12px 0;
     }

     .viewpoint-list {
       flex: 1;
       overflow-y: auto;
       margin-top: 16px;
       padding: 0 10px;
       list-style: none;

       .viewpoint-list-item {
         margin-bottom: 8px;
         position: relative;

         .viewpoint-item {
           height: 68px;
           display: flex;
           align-items: stretch;
           background: #242424;
           border: 1px solid #4F4F4F;
           border-radius: 4px;
           cursor: pointer;
           transition: background-color 0.2s;

           &:hover {
             background: #4F4F4F;
           }

           .viewpoint-thumbnail {
             width: 100px;
             height: 100%;
             border-radius: 4px 0 0 4px;
             background: rgba(214, 224, 235, 1);
             //border: 1px solid #4F4F4F;
             overflow: hidden;
             flex-shrink: 0;

             img {
               width: 100%;
               height: 100%;
               object-fit: cover;
             }
           }

           .viewpoint-info {
             flex: 1;
             display: flex;
             flex-direction: column;
             padding: 6px 8px 8px 4px;

             .viewpoint-name {
               color: rgba(255, 255, 255, 0.9);
               font-size: 14px;
               cursor: pointer;
               line-height: 1.4;

               span {
                 display: -webkit-box;
                 -webkit-box-orient: vertical;
                 -webkit-line-clamp: 2;
                 line-clamp: 2;
                 overflow: hidden;
                 text-overflow: ellipsis;
                 word-break: break-all;
               }
             }
           }
         }
         .viewpoint-operation {
           position: absolute;
           right: 0;
           bottom: 2px;
           color: #FFFFFF;
           &:hover{
             background: #4F4F4F;
           }

           .el-dropdown-link {
             color: rgba(255, 255, 255, 0.6);
             cursor: pointer;
             padding: 4px;

             &:hover {
               color: rgba(255, 255, 255, 0.9);
             }
           }
         }
       }
     }

     .empty-content{
       margin-top: 40%;
       text-align: center;
     }
   }
  .bf-btn{
    padding: 9px;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    background-position: 9px 9px;
  }
  .bf-btn-pizhu{
    .bf-btn;
    background-image: url("~@/assets/img/bf-icon-pizhu.png");
  }
  .bf-btn-shidian{
    .bf-btn;
    background-image: url("~@/assets/img/bf-icon-shidian.png");
  }
}
.bimface-annotation{
  .bf-house{
    right: 350px;
  }
  .bf-toolbar.bf-toolbar-bottom{
    left: calc(50% - 162px);
  }
}
.viewpoint-img{
  width: 322px;
  height: 180px;
  border-radius: 4px;
  border: 1px dashed #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(214, 224, 235, 1);
  img{
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: contain;
   }
 }
.red-bg:hover {
   background-color: #ff4d4f;
 }
</style>
